// extracted by mini-css-extract-plugin
export var filterIncDec = "_5h-0";
export var leftBorder = "_5h-1";
export var rightBorder = "_5h-2";
export var stringInput = "_5h-3";